import { Nes } from './nes';
import { Cartridge } from './interfaces/cartridge';

/**
 * Thin driver over Nes: runs whole frames. Integration-owned — see AGENTS.md.
 */
export class Emulator {
    private nes: Nes;

    constructor(cartridge: Cartridge) {
        this.nes = new Nes(cartridge);
    }

    /** Run until the PPU completes one full frame. */
    stepFrame(): void {
        const ppu = this.nes.getPpu();
        const targetFrame = ppu.getFrameCount() + 1;
        let guard = 0;
        while (ppu.getFrameCount() < targetFrame) {
            this.nes.step();
            if (++guard > 40000) {
                throw new Error('stepFrame guard tripped: frame did not complete');
            }
        }
    }

    getNes(): Nes {
        return this.nes;
    }
}
